module.exports = __webpack_public_path__ + "img/dp-icon.34bc75c2.svg";